"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _index = require("@/utils/index");
var _memberManagement = require("@/api/member/memberManagement");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '用户注销清单',
  data: function data() {
    return {
      // 搜索表单
      searchForm: {
        mobile: ''
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 添加对话框
      addDialogVisible: false,
      addForm: {
        userId: '',
        mobile: '',
        aliuid: '',
        unionid: '',
        reason: ''
      },
      addFormRules: {
        userId: [{
          required: true,
          message: '请输入用户ID',
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        aliuid: [{
          message: '请输入支付宝unionId',
          trigger: 'blur'
        }],
        unionid: [{
          message: '请输入微信unionId',
          trigger: 'blur'
        }],
        reason: [{
          required: true,
          message: '请选择注销原因',
          trigger: 'change'
        }]
      },
      // 审核对话框
      approveDialogVisible: false,
      currentApproveItem: {}
    };
  },
  methods: {
    // 搜索
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchTableData();
    },
    // 获取表格数据
    fetchTableData: function () {
      var _fetchTableData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              params = {
                mobile: this.searchForm.mobile,
                page: this.currentPage,
                limit: this.pageSize
              }; // 过滤空值参数
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                  delete params[key];
                }
              });
              _context.next = 2;
              return (0, _memberManagement.getCancellationList)(params);
            case 2:
              response = _context.sent;
              if (response && response.code === 200) {
                // 根据后端返回结构调整
                this.tableData = response.data && response.data.records || response.records || [];
                this.total = response.data && response.data.total || response.total || 0;
              } else {
                // 如果接口失败，显示空列表
                this.tableData = [];
                this.total = 0;
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              this.$message.warning('接口调用失败');
              // 接口失败时显示空列表
              this.tableData = [];
              this.total = 0;
            case 4:
              _context.prev = 4;
              this.loading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchTableData() {
        return _fetchTableData.apply(this, arguments);
      }
      return fetchTableData;
    }(),
    // 添加注销清单
    handleAdd: function handleAdd() {
      this.addDialogVisible = true;
      this.resetAddForm();
    },
    // 提交添加
    handleSubmitAdd: function handleSubmitAdd() {
      var _this = this;
      this.$refs.addFormRef.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var _t2;
          return regeneratorRuntime.wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!valid) {
                  _context2.next = 4;
                  break;
                }
                _context2.prev = 1;
                _context2.next = 2;
                return (0, _memberManagement.addCancellationItem)(_this.addForm);
              case 2:
                _this.$message.success('添加成功');
                _this.addDialogVisible = false;
                _this.fetchTableData();
                _context2.next = 4;
                break;
              case 3:
                _context2.prev = 3;
                _t2 = _context2["catch"](1);
                console.error('添加失败:', _t2);
                _this.$message.error('添加失败');
              case 4:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[1, 3]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 审核
    handleApprove: function handleApprove(row) {
      this.currentApproveItem = _objectSpread({}, row);
      this.approveDialogVisible = true;
    },
    // 通过审核
    handleApproveSubmit: function () {
      var _handleApproveSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _memberManagement.approveCancellation)(this.currentApproveItem.id);
            case 1:
              this.$message.success('信息已清除');
              this.approveDialogVisible = false;
              this.fetchTableData();
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('审核失败:', _t3);
              this.$message.error('审核失败');
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function handleApproveSubmit() {
        return _handleApproveSubmit.apply(this, arguments);
      }
      return handleApproveSubmit;
    }(),
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchTableData();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchTableData();
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 检查审核状态（调试用）
    checkAuditStatus: function checkAuditStatus(row) {
      return row.auditStatus == 0;
    },
    // 获取状态文本
    getStatusText: function getStatusText(status) {
      switch (status) {
        case 1:
          return '已审核';
        case 0:
          return '未审核';
        case 3:
          return '已撤销';
        default:
          return '未知状态';
      }
    },
    // 获取状态标签类型
    getStatusTagType: function getStatusTagType(status) {
      switch (status) {
        case 1:
          return 'success';
        // 已审核 - 绿色
        case 0:
          return 'info';
        // 未审核 - 灰色
        case 3:
          return 'warning';
        // 已撤销 - 橙色
        default:
          return 'info';
      }
    },
    // 重置添加表单
    resetAddForm: function resetAddForm() {
      var _this2 = this;
      this.addForm = {
        userId: '',
        mobile: '',
        aliuid: '',
        unionid: '',
        reason: ''
      };
      this.$nextTick(function () {
        _this2.$refs.addFormRef && _this2.$refs.addFormRef.clearValidate();
      });
    },
    // 对话框关闭处理
    handleDialogClose: function handleDialogClose() {
      this.addDialogVisible = false;
      this.resetAddForm();
    }
  },
  mounted: function mounted() {
    this.fetchTableData();
  }
};